import BaseService from "./BaseService";

class NotificationService {
  static async list() {
    return await BaseService.callAPI("/notifications", "GET");
  }

  static async updateNotificationStatus({ id, status }) {
    return await BaseService.callAPI(
      `/notifications/${id}/status/${status}`,
      "POST",
      null
    );
  }

  static async GetList()
  {
    return await BaseService.callAPI("/notifications/notification-categories", "GET");
  }

  static async GetNotificationById({id})
  {
    return await BaseService.callAPI(`/notifications/${id}`, "GET");
  }

  static async UpdateCustomerNotiRecipnat({data}){
    return await BaseService.callAPI("/notifications/UpdateNotificationRecipient", "PUT", data);
  }

   static async UpdateCustomerNotiBasicInfo({data}){
    return await BaseService.callAPI("/notifications/UpdateNotificationBasicContent", "PUT", data);
  }

  static async UpdateNofiication({data})
  {
    return await BaseService.callAPI("/notifications/UpdateNotificationContent", "PUT", data);
  }

  static async GetNotificationContentByKey({id, key})
  {
    return await BaseService.callAPI(`/notifications/${id}/language/${key}`, "GET");
  }

   static async CreateNotification({data})
  {
    return await BaseService.callAPI("/notifications/CreateNewNotification", "POST", data);
  }

   static async GetOthersCategory()
  {
    return await BaseService.callAPI(`/notifications/GetOthersCategory`, "GET");
  }

  static async GetNotificationClone({id})
  {
    return await BaseService.callAPI(`/notifications/notification-clone/${id}`, "GET")
  }

   static async NotificationAlreadyExist({templateName,id})
  {
    return await BaseService.callAPI( `/notifications/CheckName?id=${id}&templateName=${templateName}`, "GET")
  }

  // static async GetNotificationLogs()
  // {
  //   return await BaseService.callAPI(`/notifications/Notification-Audit`, "GET");
  // }

//   static async GetNotificationLogs(params = {}) {
//   return await BaseService.callAPI(
//     `/notifications/Notification-Audit`,
//     "GET",
//     null,
//     params
//   );
// }

// static async GetNotificationLogs(query = {}) {
//   const params = new URLSearchParams(query).toString();
//   const url = `/notifications/Notification-Audit${params ? `?${params}` : ""}`;
//   return await BaseService.callAPI(url, "GET");
// }
 static async GetNotificationLogs(query = {}) {
  // ✅ Provide defaults expected by the API
  const defaultQuery = {
    pageNo: 1,
    pageSize: 50,
    sortBy: "desc",
    sortColumn: "createdOn",
    namePattern: "", // keep empty if no search
  };

  // ✅ Merge with provided query (e.g. from search or pagination)
  const mergedQuery = { ...defaultQuery, ...query };

  // ✅ Only allow safe params
  const allowedKeys = ["pageNo", "pageSize", "sortBy", "sortColumn", "namePattern"];
  const filteredQuery = Object.fromEntries(
    Object.entries(mergedQuery).filter(([key]) => allowedKeys.includes(key))
  );

  // ✅ Build the query string
  const params = new URLSearchParams(filteredQuery).toString();
  const url = `/notifications/Notification-Audit${params ? `?${params}` : ""}`;

  console.log("📡 Final API URL:", url); // Debugging

  // ✅ Call API
  return await BaseService.callAPI(url, "GET");
 }

//  static async export({ fileType, query, filters }) {
//     const params = BaseService.cleanQueryParams(query);
//     const queryParams = new URLSearchParams(params).toString();
// console.log(queryParams,"param")
//     return await BaseService.callAPI(
//       `/notifications/export/${fileType}?${queryParams}`,
//       "GET", // ✅ follow same method pattern as users
//       null,
//       { responseType: "blob" }
//     );
//   }
static async export({ fileType, query }) {
  const params = BaseService.cleanQueryParams(query);
  const queryParams = new URLSearchParams(params).toString();

  // ✅ Manually prepend base URL since BaseService doesn’t do it
  const API_BASE_URL = process.env.REACT_APP_API_URL || "";
  console.log(" Export filetype:",fileType);
  // build full path
  const fullPath = `${API_BASE_URL}/notifications/export/${fileType}?${queryParams}`;
  console.log("📦 Export fullPath:", fullPath,fileType);

  return await BaseService.callAPI(
    fullPath,
    "GET",
    null,
    { responseType: "blob" }
  );
}

}

export default NotificationService;
